import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Row, Button, Card, Divider, Menu, Popover, Tooltip } from "antd";
import {
  UserOutlined,
  TeamOutlined,
  DeleteOutlined,
  LineChartOutlined,
  SettingOutlined,
  SyncOutlined,
  FolderOpenOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { get } from "../../helper/request";
import ModalSwap from "../modal-swap/ModalSwap";
import { useSelector } from "react-redux";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
const locale = require("react-redux-i18n").I18n;
const text = <span>Update</span>;
const menu = (props) => (
  <Menu style={{ border: "none" }} selectable={false}>
    <Menu.Item
      onClick={() => {
        props.onEditPasswordShow(props.account);
      }}
    >
      <UserOutlined className="mr-2" />

      {`${locale.t("dashboardWallet.menu.account_edit")} ${
        props.account.platform
      }`}
    </Menu.Item>
    <Menu.Item
      onClick={() => {
        props.onEditInvestorPasswordShow(props.account);
      }}
    >
      <TeamOutlined className="mr-2" />
      {locale.t("dashboardWallet.menu.investor_edit")}
    </Menu.Item>
    <Menu.Item
      onClick={() => {
        props.onEditLeverageShow(props.account);
      }}
    >
      <LineChartOutlined className="mr-2" />
      {locale.t("dashboardWallet.menu.leverage_edit")}
    </Menu.Item>
    {!props.isWelcome && (
      <Menu.Item
        onClick={() => {
          props.onDelete(props.account);
        }}
      >
        <DeleteOutlined className="mr-2" />
        {locale.t("dashboardWallet.menu.account_close")}
      </Menu.Item>
    )}
    {!props.isWelcome && (
      <Menu.Item
        onClick={() => {
          props.onArchive(props.account);
        }}
      >
        <FolderOpenOutlined className="mr-2" />
        {locale.t("dashboardWallet.menu.account_archive")}
      </Menu.Item>
    )}
  </Menu>
);

const DropdownSetting = (props) => (
  <>
    <Popover
      placement="bottom"
      content={menu(props)}
      trigger="click"
      className="cursor-pointer"
    >
      {/* <EditTwoTone twoToneColor="black" /> */}
      <img src="/assets/images/icons/icon-edit-account.svg" alt="edit" />
    </Popover>
  </>
);

const RealAccountCardX = (props) => {
  const account = props.account.account_type;
  const [isOpen, setIsOpen] = useState(false);
  const profileCountry = useSelector((state) => state.user.profileCountry);
  const { lang } = useParams();
  const contestId = props.account?.account_trade_participant?.contest_id;
  const status = props.account?.account_trade_participant?.status;
  const history = useHistory();
  const onCloseSwap = () => {
    setIsOpen(false);
  };
  const onOpenSwap = () => {
    setIsOpen(true);
    // if (!profileCountry.isalamic) {
    //   setIsOpen(true);
    // }
  };

  const handleContestNavigation = () => {
    if (contestId) {
      localStorage.setItem("contestId", contestId);
      if (status === "opening") {
        history.push(`/${lang}/wallet/contest/new-events/${contestId}`);
      } else if (status === "ended") {
        history.push(`/${lang}/wallet/contest/previous-events/${contestId}`);
      } else {
        history.push(`/${lang}/wallet/contest/new-events`);
      }
    }
  };
  
  return (
    <Card
      className="account-card"
      headStyle={{ padding: "14px !important" }}
      title={
        <>
          <div className="align-content-center d-flex justify-content-between w-100">
            <div className="d-flex align-items-center flex-column">
              <div className="">
                <div className="fs-14 fw-700 d-flex align-items-center">
                  {props.account.account_number}{" "}
                  <div
                    onClick={() => onOpenSwap()}
                    className={`${
                      profileCountry?.isalamic === 0 ? "cursor-pointer" : ""
                    } bage-free-swap-${
                      props?.account?.swap_charge ? "nonfree" : "isfree"
                    } ml-2`}
                  >
                    {props?.account?.swap_charge
                      ? "Non-Free Swap"
                      : "Free Swap"}
                    &nbsp;
                  </div>
                  {/* <div className="ml-2">
                    <InfoCircleOutlined
                      className="fs-16 text-lightgray"
                      onClick={() => onOpenSwap()}
                    />
                  </div> */}
                </div>

                <div className="d-flex fs-10">
                  {props.account?.type === "welcome"
                    ? "Welcome"
                    : props.account?.account_group?.display}
                  {/* {account} */}
                  {" • "}
                  <div className="ml-1">{props.account.platform}</div>
                </div>
              </div>
            </div>
            <div
              className="ml-2"
              style={{
                cursor: "pointer",
                outline: "none",
                boxShadow: "none",
                border: "none",
                fontSize: "14px",
                paddingRight: "8px",
                textAlign: "right",
                paddingLeft: "0",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => props.onSync(props.account)}
              {...props}
            >
              <Tooltip placement="bottom" title={text}>
                <SyncOutlined />
              </Tooltip>
            </div>
          </div>
        </>
      }
      extra={
        <div style={{ display: "flex", gap: "8px" }}>
          <DropdownSetting {...props} />
          {contestId && (
            <div
              style={{ cursor: "pointer" }}
              onClick={handleContestNavigation}
            >
              <Tooltip placement="bottom" title={"Go to contest"}>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.69482 1.33333C5.70155 1.33333 5.7083 1.33333 5.71504 1.33333L10.3067 1.33333C10.4669 1.33331 10.6229 1.33329 10.7552 1.3436C10.9003 1.35489 11.0718 1.38151 11.2459 1.46537C11.5181 1.59643 11.7377 1.81601 11.8687 2.08815C11.9526 2.2623 11.9792 2.43378 11.9905 2.57889C11.9927 2.60713 11.9944 2.63645 11.9958 2.66666H13.1674C13.1784 2.66666 13.1897 2.66664 13.2012 2.66661C13.3187 2.66634 13.4622 2.66602 13.5942 2.69228C14.1231 2.79749 14.5366 3.21096 14.6418 3.73988C14.6681 3.87194 14.6677 4.01544 14.6675 4.13287C14.6675 4.1444 14.6674 4.15567 14.6674 4.16666C14.6674 4.18993 14.6674 4.21286 14.6674 4.23545C14.6676 4.63299 14.6677 4.9278 14.6162 5.18691C14.4058 6.24475 13.5788 7.07167 12.521 7.28209C12.3082 7.32443 12.0712 7.33191 11.773 7.33314C11.2955 8.6842 10.1133 9.70221 8.66743 9.94471V10.6721C8.92863 10.6808 9.15263 10.7026 9.35761 10.7575C10.2779 11.0041 10.9966 11.7229 11.2432 12.6431C11.3346 12.9842 11.3344 13.378 11.3341 13.9083C11.3341 13.9384 11.3341 13.969 11.3341 14C11.3341 14.3682 11.0356 14.6667 10.6674 14.6667H5.33409C4.9659 14.6667 4.66743 14.3682 4.66743 14C4.66743 13.969 4.66741 13.9384 4.66739 13.9083C4.66711 13.378 4.66689 12.9842 4.75829 12.6431C5.00487 11.7229 5.72366 11.0041 6.64391 10.7575C6.84889 10.7026 7.07289 10.6808 7.33409 10.6721V9.94471C5.88824 9.70221 4.70605 8.6842 4.2285 7.33314C3.93031 7.33191 3.69337 7.32443 3.48052 7.28209C2.42268 7.07167 1.59575 6.24475 1.38533 5.18691C1.33379 4.9278 1.33391 4.63299 1.33407 4.23544C1.33408 4.21285 1.33409 4.18993 1.33409 4.16666C1.33409 4.15567 1.33407 4.14439 1.33404 4.13286C1.33377 4.01544 1.33344 3.87194 1.35971 3.73988C1.46492 3.21096 1.87838 2.79749 2.40731 2.69228C2.53937 2.66602 2.68287 2.66634 2.80029 2.66661C2.81182 2.66664 2.8231 2.66666 2.83409 2.66666H4.00574C4.0071 2.63645 4.00882 2.60713 4.01102 2.57889C4.02232 2.43378 4.04893 2.2623 4.1328 2.08815C4.26386 1.81601 4.48344 1.59643 4.75558 1.46537C4.92973 1.38151 5.10121 1.35489 5.24632 1.3436C5.37863 1.33329 5.53464 1.33331 5.69482 1.33333ZM4.00076 4H2.83409C2.75213 4 2.70733 4.00009 2.67461 4.00121C2.67252 4.00128 2.67061 4.00135 2.66885 4.00143C2.66878 4.00318 2.66871 4.0051 2.66864 4.00718C2.66752 4.0399 2.66743 4.0847 2.66743 4.16666C2.66743 4.66327 2.67065 4.81422 2.69305 4.92679C2.79825 5.45571 3.21172 5.86917 3.74064 5.97438C3.80077 5.98634 3.87186 5.99283 4.00076 5.99629V4ZM5.33409 3.04762C5.33409 2.85945 5.33456 2.7565 5.34033 2.6824C5.34057 2.6793 5.34082 2.67638 5.34106 2.67363C5.34381 2.67339 5.34673 2.67315 5.34982 2.67291C5.42393 2.66714 5.52688 2.66666 5.71504 2.66666H10.2865C10.4746 2.66666 10.5776 2.66714 10.6517 2.67291C10.6548 2.67315 10.6577 2.67339 10.6605 2.67363C10.6607 2.67638 10.6609 2.6793 10.6612 2.6824C10.667 2.7565 10.6674 2.85945 10.6674 3.04762V6C10.6674 6.18352 10.649 6.36204 10.6141 6.53404C10.3671 7.75096 9.29009 8.66667 8.00076 8.66667C6.71142 8.66667 5.63447 7.75096 5.38745 6.53404C5.35253 6.36204 5.33409 6.18352 5.33409 6V3.04762ZM12.0008 4V5.99629C12.1297 5.99283 12.2007 5.98634 12.2609 5.97438C12.7898 5.86917 13.2033 5.45571 13.3085 4.92679C13.3309 4.81422 13.3341 4.66327 13.3341 4.16666C13.3341 4.0847 13.334 4.0399 13.3329 4.00718C13.3328 4.0051 13.3327 4.00318 13.3327 4.00143C13.3309 4.00135 13.329 4.00128 13.3269 4.00121C13.2942 4.00009 13.2494 4 13.1674 4H12.0008ZM8.00076 12C7.33786 12 7.13719 12.0057 6.989 12.0454C6.52888 12.1687 6.16948 12.5281 6.04619 12.9882C6.02497 13.0674 6.01346 13.1616 6.00733 13.3333H9.99418C9.98806 13.1616 9.97655 13.0674 9.95533 12.9882C9.83204 12.5281 9.47264 12.1687 9.01252 12.0454C8.86433 12.0057 8.66366 12 8.00076 12Z"
                    fill="#F1BF06"
                  />
                </svg>
              </Tooltip>
            </div>
          )}
        </div>
      }
    >
      <Row gutter={[8, 8]}>
        <div span={12} className="ant-respon w-100" style={{ padding: "6px" }}>
          <div className="d-flex justify-content-between w-100 mb-3">
            <div className="fs-12 ">{locale.t("dashboardWallet.server")}</div>
            <div className="fs-14 fw-700">
              {props.account.api_server === "api"
                ? "IUXMarkets-Live"
                : props.account.api_server === "live2"
                ? "IUXMarkets-Live2"
                : props.account.api_server === "live3"
                ? "IUXMarkets-Live3"
                : props.account.api_server === "demo"
                ? "IUXMarkets-Demo"
                : "IUXMarkets"}
            </div>
          </div>
          <div className="d-flex justify-content-between w-100 mb-3">
            <div className="fs-12 ">
              {locale.t("dashboardWallet.accountBalance")} (
              {account === "Cent" ? "USC" : "USD"})
            </div>
            <div className="fs-14 fw-700">
              {/* {(
                Math.floor(props.account.current_balance * 100) / 100
              ).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} */}
              {props.account.current_balance.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>
          <div className="d-flex justify-content-between w-100 mb-3">
            <div className="fs-12 ">
              {locale.t("dashboardWallet.accountCredit")} (
              {account === "Cent" ? "USC" : "USD"})
            </div>
            <div className="fs-14 fw-700">
              {/* {(
                Math.floor(props.account.current_credit * 100) / 100
              ).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} */}
              {props.account.current_credit.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>

          <div className="d-flex justify-content-between w-100 mb-3">
            <div className="fs-12 ">
              {locale.t("dashboardWallet.accountLeverage")}
            </div>
            <div className="fs-14 fw-700">
              1 : {props.account.current_leverage}
            </div>
          </div>
          {/* <div className="d-flex justify-content-between w-100 ">
            <div className="fs-12 ">Swap </div>
            <div className="fs-14 fw-600 ">
              <span
                className={`${
                  props?.account?.swap_charge
                    ? "text-lightgray-iux"
                    : "text-primary-sub-iux"
                }`}
              >
                {props?.account?.swap_charge ? "Non-Free" : "Free"}
              </span>
              &nbsp;{" "}
              <span>
                <InfoCircleOutlined
                  className="fs-16 text-lightgray"
                  onClick={() => onOpenSwap()}
                />
              </span>
            </div>
          </div> */}
        </div>
      </Row>
      <Row className="w-100">
        {props.isWelcome ? (
          <div className="d-flex justify-content-between text-center w-100">
            <Button
              onClick={() => props.onWithdraw(true, props.account)}
              className="btn-primary-new-iux w-100 "
              type="primary"
              style={{ borderRadius: 8 }}
            >
              {locale.t("dashboardFund.withdraw")}
            </Button>

            <Button
              className="btn-primary-new-outline ml-2 w-100"
              onClick={() => props.onInfoBonus(true)}
            >
              {locale.t("conditions")}
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="14.919"
                viewBox="0 0 24 14.919"
              >
                <path
                  id="thefreeforty_withdraw_icon-icons.com_66307"
                  d="M22.092,5.8H2.308A2.164,2.164,0,0,0,.2,7.989v5.027a2.18,2.18,0,0,0,2.189,2.189H4.416a.64.64,0,0,0,.649-.649.6.6,0,0,0-.649-.649H2.308a.986.986,0,0,1-.973-.973V7.989a.986.986,0,0,1,.973-.973h19.7a.986.986,0,0,1,.973.973v4.865a.986.986,0,0,1-.973.973H19.416a.64.64,0,0,0-.649.649.6.6,0,0,0,.649.649h2.595A2.18,2.18,0,0,0,24.2,12.935V8.07A2.185,2.185,0,0,0,22.092,5.8Zm-.568,3.243a.64.64,0,0,0-.649-.649H3.443a.64.64,0,0,0-.649.649.6.6,0,0,0,.649.649H20.876A.64.64,0,0,0,21.524,9.043Zm-3.811,1.216a.592.592,0,0,0-.811.324,11.853,11.853,0,0,0-.324,2.838c-.081,2.027-.162,4.784-1.459,6.081H5.876c1.135-1.784,1.216-4.378,1.3-6.324a10.493,10.493,0,0,1,.162-2.027.6.6,0,0,0-1.054-.568A5.953,5.953,0,0,0,5.957,13.1c-.081,2.108-.162,5.27-1.784,6.568a.631.631,0,0,0-.162.649.61.61,0,0,0,.568.405H15.443a.619.619,0,0,0,.405-.162c1.865-1.622,1.946-4.784,2.027-7.135a8.266,8.266,0,0,1,.243-2.351A.669.669,0,0,0,17.714,10.259Zm-5.838,2.595c1.459,0,2.595-.892,2.595-2.027H9.281A2.443,2.443,0,0,0,11.876,12.854Z"
                  transform="translate(-0.2 -5.8)"
                  fill="#1cb894"
                />
              </svg> */}
            </Button>
          </div>
        ) : (
          <div className="d-flex justify-content-between text-center w-100">
            <Link
              to={{
                pathname: `/${localStorage.getItem(
                  "locale"
                )}/wallet/fund/deposit`,
                search: `?account=${props.account.account_number}`,
                state: { account: props.account },
              }}
              className="w-100"
            >
              <Button
                // onClick={setDeposit}
                className="btn-primary-new-iux w-100 "
                type="primary"
                style={{ borderRadius: 8 }}
              >
                {locale.t("dashboardFund.deposit")}
              </Button>
            </Link>{" "}
            <div className="px-1" />
            <Link
              to={{
                pathname: `/${localStorage.getItem(
                  "locale"
                )}/wallet/fund/withdraw`,
                search: `?account=${props.account.account_number}`,
              }}
              className="w-100 "
            >
              <Button className="btn-primary-new-outline w-100">
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="14.919"
                  viewBox="0 0 24 14.919"
                >
                  <path
                    id="thefreeforty_withdraw_icon-icons.com_66307"
                    d="M22.092,5.8H2.308A2.164,2.164,0,0,0,.2,7.989v5.027a2.18,2.18,0,0,0,2.189,2.189H4.416a.64.64,0,0,0,.649-.649.6.6,0,0,0-.649-.649H2.308a.986.986,0,0,1-.973-.973V7.989a.986.986,0,0,1,.973-.973h19.7a.986.986,0,0,1,.973.973v4.865a.986.986,0,0,1-.973.973H19.416a.64.64,0,0,0-.649.649.6.6,0,0,0,.649.649h2.595A2.18,2.18,0,0,0,24.2,12.935V8.07A2.185,2.185,0,0,0,22.092,5.8Zm-.568,3.243a.64.64,0,0,0-.649-.649H3.443a.64.64,0,0,0-.649.649.6.6,0,0,0,.649.649H20.876A.64.64,0,0,0,21.524,9.043Zm-3.811,1.216a.592.592,0,0,0-.811.324,11.853,11.853,0,0,0-.324,2.838c-.081,2.027-.162,4.784-1.459,6.081H5.876c1.135-1.784,1.216-4.378,1.3-6.324a10.493,10.493,0,0,1,.162-2.027.6.6,0,0,0-1.054-.568A5.953,5.953,0,0,0,5.957,13.1c-.081,2.108-.162,5.27-1.784,6.568a.631.631,0,0,0-.162.649.61.61,0,0,0,.568.405H15.443a.619.619,0,0,0,.405-.162c1.865-1.622,1.946-4.784,2.027-7.135a8.266,8.266,0,0,1,.243-2.351A.669.669,0,0,0,17.714,10.259Zm-5.838,2.595c1.459,0,2.595-.892,2.595-2.027H9.281A2.443,2.443,0,0,0,11.876,12.854Z"
                    transform="translate(-0.2 -5.8)"
                    fill="#1cb894"
                  />
                </svg> */}
                {locale.t("dashboardFund.withdraw")}
              </Button>
            </Link>{" "}
          </div>
        )}
      </Row>
      <ModalSwap
        isOpen={isOpen}
        onClose={onCloseSwap}
        isFree={props?.account?.swap_charge}
        isAccountId={props?.account?.id}
      />
    </Card>
  );
};
export default RealAccountCardX;
